import { FC, useEffect } from 'react'
import ReactGA from 'react-ga4'
import type { ITemplate } from '../interfaces/templates'
import { useAlternativeProductsPdpTrigger } from '../hooks/recommendations'
import Default from './Default'

const ProductDetail: FC<ITemplate> = ({ ...props }) => {
  // SKU-keyed "Opciones similares" fetch — triggered here (not via a Carousel
  // `runOnLoad`) because the displayed sku is only reliably available from the
  // route on the mounted PDP. Gated on the carousel being configured for this
  // storefront (ships dark), so unconfigured tenants don't fire the query.
  // See useAlternativeProductsPdpTrigger.
  useAlternativeProductsPdpTrigger(props.container)

  useEffect(() => {
    ReactGA.send({ hitType: 'pageview', page: `/${props.container.uid}` })
    window.fbq('track', 'PageView', { page: `/${props.container.uid}` })
  }, [])
  return <Default {...props} />
}

export default ProductDetail
